"use client";

import { ScrollText, GitBranch, Container, Activity } from "lucide-react";
import ServicePage from "@/components/ServicePage";
import MetadataUpdater from "@/components/MetadataUpdater";
import { serviceSummary } from "@/data/knowledge/services";

export default function DevOpsPage() {
  return (
    <>
    <MetadataUpdater
      titleKey="meta.solutions.devops.title"
      description={serviceSummary("devops")}
    />
    <ServicePage
      labelKey="service.devops.label"
      titleKey="service.devops.title"
      descriptionKey="service.devops.description"
      benefits={[
        {
          icon: ScrollText,
          titleKey: "service.devops.benefit1.title",
          descKey: "service.devops.benefit1.desc",
        },
        {
          icon: GitBranch,
          titleKey: "service.devops.benefit2.title",
          descKey: "service.devops.benefit2.desc",
        },
        {
          icon: Container,
          titleKey: "service.devops.benefit3.title",
          descKey: "service.devops.benefit3.desc",
        },
        {
          icon: Activity,
          titleKey: "service.devops.benefit4.title",
          descKey: "service.devops.benefit4.desc",
        },
      ]}
      usecaseKeys={[
        "service.devops.usecase1",
        "service.devops.usecase2",
        "service.devops.usecase3",
        "service.devops.usecase4",
      ]}
      stack={[
        "Docker",
        "Terraform",
        "OpenTofu",
        "Ansible",
        "GitHub Actions",
        "Prometheus",
        "Grafana",
        "Sentry",
        "AWS",
        "Azure",
        "GCP",
        "Cloudflare",
        "Proxmox",
      ]}
    />
    </>
  );
}
